import styled from 'styled-components';

import { fontWeight, FontWeights, minWidth } from '@calm-web/design-system';

export const Wrapper = styled.div`
	background: linear-gradient(180deg, #ffffff 0%, #eff0ff 100%);
	overflow: hidden;
	padding: 130px 0 140px;
	position: relative;
`;

export const Grid = styled.div`
	margin: 0 auto;
	max-width: calc(100% - 40px);

	${minWidth('desktop')} {
		display: grid;
		grid-gap: 40px;
		grid-template-columns: 2fr 2fr;
		max-width: 960px;
	}
`;

export const Content = styled.div`
	text-align: center;

	${minWidth('desktop')} {
		text-align: left;
	}
`;

export const WhatYouGetTitle = styled.h2`
	color: #383838;
	${fontWeight(FontWeights.Regular)};
	font-size: 40.5px;
	grid-column: 1 / 3;
	line-height: 1.5;
	margin: 0 0 48px;
	padding: 0;
`;

export const FeatureList = styled.ul`
	display: grid;
	grid-template-columns: 1fr;
	grid-gap: 36px;
	margin: 0;
	padding: 0;

	${minWidth('tablet')} {
		grid-template-columns: 1fr 1fr;
	}

	${minWidth('desktop')} {
		display: block;
	}
`;

export const Bullet = styled.li`
	align-items: flex-start;
	display: flex;
	margin-bottom: 24px;
	text-align: left;
`;

export const Icon = styled.div`
	flex: 0 0 64px;
	height: 64px;
	position: relative;
	top: 8px;
	width: 64px;

	& svg {
		height: 100%;
		width: 100%;
	}
`;

export const BulletCopy = styled.div`
	color: #383838;
	margin-left: 30px;
`;

export const Subheading = styled.h4`
	font-size: 22.5px;
	${fontWeight(FontWeights.Medium)};
	line-height: 1.5;
	margin-bottom: 8px;
	padding: 0;
`;

export const BodyText = styled.div`
	${fontWeight(FontWeights.Light)};
	font-size: 18px;
	line-height: 1.5;
`;

export const ComputerContainer = styled.div`
	display: none;
	position: relative;

	${minWidth('desktop')} {
		display: block;
	}
`;

export const DesktopComputer = styled.img`
	height: 500px;
	width: auto;
	position: absolute;
	left: 70px;
	top: 70px;
`;

export const MobileDevice = styled.img`
	max-width: 420px;
	width: calc(100% - 40px);
	margin: 0 auto 60px;

	${minWidth('desktop')} {
		display: none;
	}
`;
